<div>
  <div *ngIf="loading">
    <div class="loader is-active padding-leader-3 padding-trailer-3">
      <div class="loader-bars"></div>
      <div class="loader-text">Loading...</div>
    </div>
  </div>
  <div *ngIf="!loading">
    <div *ngIf="imgVideoDocs.length > 0">
      <div class="navigation" *ngIf="imgVideoDocs.length > 1">
        <div class="left">
          <button class="btn" *ngIf="currentIndex > 0" (click)="moveBackward()">
            <span class="icon icon-ui-left-triangle-arrow"></span>
          </button>
        </div>
        <div class="current-of-total">
            {{ currentIndex + 1 }} of {{ imgVideoDocs.length }}
        </div>
        <div class="right">
          <button class="btn" *ngIf="currentIndex < imgVideoDocs.length - 1" (click)="moveForward()">
            <span class="icon icon-ui-right-triangle-arrow"></span>
          </button>
        </div>
      </div>
      <mc-doc-source-item-ng #docSourceItem *ngFor="let doc of imgVideoDocs" [document]="doc" [currentFeature]="currentRecord"
        [currentDocument]="currentDocument" (onLargerImageRequested)="onLargerImageRequested($event)">
      </mc-doc-source-item-ng>
    </div>
    <mc-tree-explorer-ng [documents]="documents" [buildGroups]="buildDocumentGroups"></mc-tree-explorer-ng>
  </div>
</div>
